function addLoader()
{
	var overlay="<div id=\"overlay_admin_ajax\" class=\"overlay\"><i class=\"fas fa-3x fa-sync-alt fa-spin\"></i></div>";

	$("body").append(overlay);
	console.log("Add Loader");
}


function removeLoader()
{
	$("#overlay_admin_ajax").remove();

	console.log("Remove Loader");
}


if(document.querySelector("#add-record")) {
    document.querySelector("#add-record").addEventListener('submit', function(event) {
        event.preventDefault();
        const oFormData = new FormData(document.querySelector("#add-record"));
        
        addLoader();
        fetch(document.querySelector("#add-record").getAttribute('action'), {
            method: 'POST',
            headers: {
                "X-CSRF-TOKEN" : X_CSRF_TOKEN,
                "Accept": "application/json",
            },
            body: oFormData,
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            removeLoader();
            if(data.type == "success"){
                alertify.success("Registro guardado de manera exitosa!");
                setTimeout(() => {
                	window.location = URL_INDEX;
                }, 1000);
            }
            else if(data.type == "error"){
                alertify.error(data.message);
            }
            else{
                alertify.error(data.message || "No fue posible guardar el registro");
            }
        })
        .catch((error) => {
        	removeLoader();
            alertify.error("No fue posible guardar el registro");
        });
    });
}


if(document.querySelector("#edit-record")) {
    document.querySelector("#edit-record").addEventListener('submit', function(event) {
        event.preventDefault();
        const oFormData = new FormData(document.querySelector("#edit-record"));
        
        addLoader();
        fetch(document.querySelector("#edit-record").getAttribute('action'), {
            method: 'POST',
            headers: {
                "X-CSRF-TOKEN" : X_CSRF_TOKEN,
                "Accept": "application/json",
            },
            body: oFormData,
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            removeLoader();
            if(data.type == "success"){
                alertify.success("Registro actualizado de manera exitosa!");
                setTimeout(() => {
                	window.location = URL_INDEX;
                }, 1000);
            }
            else if(data.type == "error"){
                alertify.error(data.message);
            }
            else{
                alertify.error(data.message || "No fue posible actualizar el registro");
            }
        })
        .catch((error) => {
        	removeLoader();
            alertify.error("No fue posible actualizar el registro");
        });
    });
}


function urlDeleteButtonModule(classButtonDelete=".btn-primary-delete-module-select")
{
    if($(classButtonDelete).length>0){
        $(classButtonDelete).click(function(event){
            event.preventDefault();
            let ObjClickButton=$(this);
            alertify.confirm('Consola de Administración', '¿Estás seguro de borrar el registro?', 
                function()
                {
                    $.ajax({
                        url: ObjClickButton.attr("href"),
                        method:'get',
                        async :true,
                        cache: false,
                        beforeSend:function(){
                            addLoader();
                        }
                    }).done(function(data){
                        removeLoader();
                        if(data.type=="success" || data.error=="success")
                        {
                            alertify.success("Registro Borrado de manera exitosa");
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                        else if(data.type=="error")
                        {
                            alertify.error(data.message);
                        }
                        else
                        {
                            alertify.error(data.message || "No fue posible borrar el registro");
                        }
                    }).fail(function(data){
                        removeLoader();
                        alertify.error('No fue posible borrar el registro intente de nuevo');
                    });
                },
                function()
                { 

                }
            );
        });
    }
}

function updateTheme(bDark) {
    const oBody = document.querySelector('body');
    const oMainHeader = document.querySelector('.main-header');
    if(bDark){
        oBody.classList.add('dark-mode');
        oMainHeader.classList.remove('navbar-light');
        oMainHeader.classList.add('navbar-dark');
    } else {
        oBody.classList.remove('dark-mode');
        oMainHeader.classList.remove('navbar-dark');
        oMainHeader.classList.add('navbar-light');
    }
}

async function updateThemeSession(sVal) {
    var sXRFCToken = decodeURIComponent(readCookie("XSRF-TOKEN"));
    const url = `${sBaseUrl}/themes`;
    const parameters = { method: 'POST', headers: {'Content-Type': 'application/json', 'X-XSRF-TOKEN': sXRFCToken }, body: JSON.stringify({'theme': sVal}) };
    const request = await fetch(url, parameters).catch(err => console.log(err));
}

console.log(document.querySelector('.theme-switch-wrapper'));
if(document.querySelector('.theme-switch-wrapper')){
    document.querySelector('input#theme-checkbox').addEventListener('change', e => {
        updateThemeSession(e.currentTarget.checked ? 'dark-theme' : 'light-theme');
        updateTheme(e.currentTarget.checked);
    })
}

// This file is now loaded as an ES module by Vite, whose top-level
// declarations no longer leak onto `window` the way a classic script's did.
// Many Blade views call these functions directly from their own inline
// <script> blocks, so they still need to be exposed as globals.
window.addLoader = addLoader;
window.removeLoader = removeLoader;
window.urlDeleteButtonModule = urlDeleteButtonModule;
window.updateTheme = updateTheme;
